import { useMemo } from 'react';
import { Box } from '@mui/material';

import { FHSimpleTable } from '../../../base';
import { history } from '../../../../helpers';
import { questionnaireHistoryDataTransformer } from '../utils';
import { getHistoryTableOptions, questionnaireHistoryColumns } from '../table-configs/';
import { QUESTIONNAIRE_HISTORY_TYPE } from '../constants';
import {
  ONBOARDING_QUESTIONNAIRE_BASE_PATH,
  ONBOARDING_TAB_IDS,
} from '../../../../pages/questionnaires/onboarding/constants';
import {
  INTAKE_QUESTIONNAIRE_BASE_PATH,
  INTAKE_TAB_IDS,
} from '../../../../pages/questionnaires/intake/constants';

import type { IQuestionnaireHistoryTableProps, QuestionnaireHistoryTableRow } from './types';

function QuestionnaireHistoryTable({
  onboardingQuestionnaires = [],
  intakeQuestionnaires = [],
  documentType,
}: IQuestionnaireHistoryTableProps) {
  const historyTableData = useMemo(
    () => questionnaireHistoryDataTransformer(onboardingQuestionnaires, intakeQuestionnaires),
    [onboardingQuestionnaires, intakeQuestionnaires],
  );

  const tableOptions = useMemo(() => {
    return {
      ...getHistoryTableOptions(documentType),
      onRowClick: (_rowData: QuestionnaireHistoryTableRow, rowMeta: { dataIndex: number }) => {
        const row = historyTableData[rowMeta.dataIndex];
        if (!row) return;
        history.navigate(
          row.type === QUESTIONNAIRE_HISTORY_TYPE.ONBOARDING
            ? `${ONBOARDING_QUESTIONNAIRE_BASE_PATH}/${row.id}/${ONBOARDING_TAB_IDS.INTRODUCTION}`
            : `${INTAKE_QUESTIONNAIRE_BASE_PATH}/${row.id}/${INTAKE_TAB_IDS.INTRODUCTION}`,
        );
      },
    };
  }, [documentType, historyTableData]);

  return (
    <Box data-testid="historicalQuestionnairesTable">
      <FHSimpleTable
        data={historyTableData}
        columnDefinitions={questionnaireHistoryColumns}
        columnOptions={tableOptions}
      />
    </Box>
  );
}

export default QuestionnaireHistoryTable;
